/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForElasticSearch extends models.ServiceAccountCredentialsForBasicAuth {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForElasticSearch");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForElasticSearch.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForElasticSearch>): ServiceAccountCredentialsForElasticSearch {
        let obj = Object.assign(new ServiceAccountCredentialsForElasticSearch(), model);
        ServiceAccountCredentialsForElasticSearch.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForElasticSearch>): ServiceAccountCredentialsForElasticSearch {
        if (!model) return null;
        return ServiceAccountCredentialsForElasticSearch.newInstance(<ServiceAccountCredentialsForElasticSearch> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForElasticSearch) {
        if (!obj) return;

        models.ServiceAccountCredentialsForElasticSearch.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForElasticSearch): boolean {
        if (models.ServiceAccountCredentialsForBasicAuth.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForElasticSearch.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
